import { useRecoilState } from "recoil";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { IconButton } from "@mui/material";

import { favoritesAtom } from "../atom";
import { FavoriteItem } from "../../AuthProvider";
import { getDefaultOptions } from "../../services/Category";

const updateFavoritesApi = async (favorites: FavoriteItem[]): Promise<void> => {
  const response = await fetch(
    "/api/users/update-favorites/",
    getDefaultOptions({
      method: "PATCH",
      body: JSON.stringify({ menu_favorites: favorites }),
    })
  );

  if (!response.ok) {
    throw new Error("Failed to update favorites");
  }
};

const FavoriteButton = ({ id, label }: FavoriteItem) => {
  const [favorites, setFavorites] = useRecoilState(favoritesAtom);
  const isFavorite = favorites.some((f) => f.id === id);

  const toggle = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const next = isFavorite
      ? favorites.filter((f) => f.id !== id)
      : [...favorites, { id, label }];

    setFavorites(next);

    try {
      await updateFavoritesApi(next);
    } catch (error) {
      console.error("Failed to update favorites:", error);
      setFavorites(favorites);
    }
  };

  return (
    <IconButton
      size="small"
      onClick={toggle}
      sx={(theme) => ({
        p: "2px",
        flexShrink: 0,
        "&& svg": {
          fontSize: "1rem",
          fill: isFavorite
            ? theme.vars.palette.text.accentInverted
            : theme.vars.palette.menu.text,
        },
        "&&:hover svg": {
          fill: isFavorite
            ? theme.vars.palette.menu.text
            : theme.vars.palette.text.accentInverted,
        },
      })}
    >
      {isFavorite ? (
        <StarIcon fontSize="small" />
      ) : (
        <StarBorderIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default FavoriteButton;
